import { API } from '../../../vendor/api';
export const getTaxAmount = async (email, planId, postalCode, countryCode, seats, coupon) => {
    return await API.stripe.getTaxAmount({
        email,
        planId,
        postalCode,
        countryCode,
        seats,
        coupon,
    });
};
